import { Badge, Box, Button, ButtonGroup, Flex, FormatNumber, Grid, GridItem, HStack, Image, Separator, Spinner, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import useUser from "hooks/useUser"
import useAdhesionKits from "hooks/useAdhesionKits"
import { useEffect, useState } from "react"

import DialogDistributors from './distributors'
import { API } from "config"
import { toaster } from "config"

export default function Register(){

    const user = useUser()
    const [ kit, setKit ] = useState()
    const [ method, setMethod ] = useState()
    const [ distributor, setDistributor ] = useState(null)
    const [ shipping_type, setShipping ] = useState()
    const [ payment_method, setPayment ] = useState(5)
    const kits = useAdhesionKits(method, distributor?.id)
    const [ quote, setQuote ] = useState()
    const [ loading, setLoading ] = useState(false)

    const getKits = () => {
        if(method==='consultant') return kits.data ?? [];
        if(method==='distributor') return kits.data?.filter(item => !!item.stock && item.stock.available >= 1) ?? []
    }

    const handleQuote = async () => {
        if(!kit || !method) return
        if(method === 'distributor' && !distributor) return
        setLoading('quote')

        try{
            // Alterado para usar o shipping_type do estado atual, caindo para 2 apenas se for undefined
            const currentShipping = shipping_type ?? 2;
            const callback = await API.get(`/adhesion/quote?method=${method}&product_kit_id=${kit}${payment_method ? `&transaction_method=${payment_method}` : ''}&shipping_type=${currentShipping}${distributor ? `&distributor_id=${distributor.id}` : ''}`)
            setQuote(callback.data)
        }catch(err){
            //toaster.create({ title: 'Não foi possível realizar a cotação.', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    const handleSubmit = async () => {
        setLoading('submit')

        try{
            // Enviando shipping_type explicitamente do estado
            await API.post('/adhesion', {
                method,
                product_kit_id: kit,
                transaction_method: payment_method,
                shipping_type,
                distributor_id: distributor?.id
            })
            toaster.create({ title: 'Pedido de adesão registrado.', description: 'Redirecionando...', type: 'success' })
            setTimeout(() => { window.location.reload() }, 2000)
        }catch(err){
            toaster.create({ title: 'Não foi possível registrar a adesão.', description: err?.response?.data?.message })
            setLoading(false)
        }
    }

    useEffect(() => {
        handleQuote()
    }, [method, shipping_type, kit, payment_method])

    // Efeito 1: Reset ao mudar o método de ativação
    useEffect(() => {
        setKit(null)
        setPayment(null)

        if (method === 'consultant') {
            setDistributor(null)
            setShipping(2) // Consultor parceiro é sempre retirada
        } else {
            setShipping(null) // Reseta para o próximo efeito decidir o padrão do núcleo
        }
    }, [method])

    // Efeito 2: Sugestão de frete e pagamento ao selecionar distribuidor
    useEffect(() => {
        if (method === 'distributor' && distributor) {
            if (!distributor?.is_warehouse) {
                setPayment(4)
                // Sugere retirada (2) se for núcleo comum e o usuário ainda não escolheu
                setShipping(prev => prev || 2)
            } else {
                setPayment(5)
                // Sugere entrega (1) se for matriz e o usuário ainda não escolheu
                setShipping(prev => prev || 1)
            }
        }
    }, [distributor, method])


    return(
        <>
            <DialogDistributors selected={distributor} open={method==='distributor'&&!distributor} onChange={dist => setDistributor(dist)} />

            <Form.Container mt={4}>

                <Text color="GrayText">Como deseja ser ativado?</Text>

                <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>
                    <GridItem><Option selected={method==='distributor'} onClick={() => setMethod('distributor')} colorPalette="teal" title="Núcleo" icon="distributor" tagline="Você pode retirar seu kit em um núcleo próximo a você." /></GridItem>
                    <GridItem><Option selected={method==='consultant'} onClick={() => setMethod('consultant')} colorPalette="orange" title="Consultor Parceiro" tagline="Seu kit deverá ser retirado com um consultor parceiro." /></GridItem>
                </Grid>

                <UI.Show visible={method==='distributor'&&!!distributor}>
                    <Separator />
                    <Text color="GrayText">Núcleo selecionado:</Text>

                    <Flex justifyContent="space-between" borderWidth={1} p={4} borderRadius={4} borderColor="teal.fg" borderStyle="dotted">
                        <HStack>
                            <UI.Avatar name={distributor?.name} colorPalette="teal" />
                            <Box>
                                <Text fontWeight="bold" color="teal.focusRing">{distributor?.name}</Text>
                            </Box>
                        </HStack>
                        <ButtonGroup>
                            <Button colorPalette="teal" size="xs" onClick={() => setDistributor(null)}><UI.Icon name="edit" /> Alterar núcleo</Button>
                        </ButtonGroup>
                    </Flex>
                </UI.Show>

                <UI.Show visible={method==='consultant' || (method==='distributor' && !!distributor)}>
                    <Separator />
                    <Text color="GrayText">Clique no kit de adesão desejado:</Text>

                    <UI.Show visible={kits.isFetching}><UI.Alert size="sm" indicator={<Spinner />}>Buscando kits disponíveis...</UI.Alert></UI.Show>
                    <UI.Show visible={method==='distributor' && !getKits()?.length && !kits.isFetching}><UI.Alert size="sm" status="warning">O núcleo <b>{distributor?.name}</b> não possui kits de adesão disponíveis. Por favor selecione outro núcleo ou a <b>Matriz</b>.</UI.Alert></UI.Show>

                    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }} gap={4}>
                        { getKits()?.map(item => <GridItem key={item.id}><Kit onClick={() => setKit(item.id)} selected={kit === item.id} data={item} colorPalette="orange" /></GridItem>) }
                    </Grid>
                </UI.Show>


                <UI.Show visible={!!kit && method === 'distributor'}>
                    <Separator />
                    <Text color="GrayText">Selecione o tipo de envio:</Text>

                    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>
                        <GridItem><Option selected={shipping_type===1} icon="shipping" onClick={() => setShipping(1)} title="Entrega" tagline="Envio para todo o Brasil." /></GridItem>
                        <GridItem><Option selected={shipping_type===2} onClick={() => setShipping(2)} title="Retirada" tagline="Retirar o item no núcleo selecionado." /></GridItem>
                    </Grid>
                </UI.Show>

                <UI.Show visible={(method==='distributor') && !!kit}>
                    <Separator />
                    <Text color="GrayText">Clique na forma de pagamento desejada:</Text>

                    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>
                        <UI.Show visible={method==='distributor'&&distributor?.is_warehouse}>
                            <GridItem>
                                <Option
                                    selected={payment_method === 9}
                                    onClick={() => setPayment(9)}
                                    colorPalette="orange"
                                    title="Cielo"
                                    tagline="Pague online com cartão de crédito ou pix"
                                />
                            </GridItem>
                        </UI.Show>
                        <UI.Show visible={method==='distributor'&&!distributor?.is_warehouse}><GridItem><Option selected={payment_method === 4} onClick={() => setPayment(4)} colorPalette="orange" icon="pix" title="Pix" tagline="Realize o pagamento diretamente para o núcleo." /></GridItem></UI.Show>
                    </Grid>
                </UI.Show>

                <Separator />

                <UI.Show visible={method==='consultant'}>
                    <UI.Alert size="sm">
                        Você selecionou a ativação através de um <b>Consultor Parceiro</b>. Esta opção não possui formas de pagamento pois ao realizar o pedido de adesão, um consultor deverá
                        realizar a sua ativação através de <b>Voucher</b>.
                    </UI.Alert>
                </UI.Show>

                <UI.Show visible={!!kit}>
                    <HStack>
                        <UI.Show visible={loading==='quote'}>
                            <Spinner />
                        </UI.Show>
                        <Box>
                            <Text color="GrayText">Valor total:</Text>
                            <Text fontSize="lg" color="green.fg" fontWeight="bold"><FormatNumber value={quote?.total_amount / 100} style="currency" currency="BRL" /></Text>
                            <UI.Show visible={shipping_type === 1}><Text fontSize="sm" color="GrayText">Valor da entrega: <FormatNumber value={quote?.shipping_amount / 100} style="currency" currency="BRL" /></Text></UI.Show>
                        </Box>
                    </HStack>
                </UI.Show>

                <Button size="lg" colorPalette="orange" mt={4} loading={loading==='submit'} disabled={!!loading || !kit} onClick={handleSubmit}>Realizar pedido de adesão <UI.Icon name="next" /></Button>

            </Form.Container>
        </>

    )
}

const Option = ({ title, tagline, image_src, icon, colorPalette = 'gray', selected = false, ...props}) => {
    return(
        <UI.Pressable {...props}>
            <Box py={3} px={4} borderWidth={1} borderRadius={4} borderColor={selected?`${colorPalette}.fg`:'gray.200'} background={selected?`${colorPalette}.muted`:null} transition="all 0.2s">
                <HStack gap={4}>
                    <Box>
                        <UI.Avatar icon={icon && <UI.Icon name={icon} fontSize={30} />} src={image_src} colorPalette={colorPalette} />
                    </Box>
                    <Box>
                        <Text fontWeight={selected ? "bold" : "normal"}>{title}</Text>
                        <Text fontSize="xs" color="GrayText">{tagline}</Text>
                    </Box>
                </HStack>
            </Box>
        </UI.Pressable>
    )
}

const Kit = ({ data, selected, ...props }) => {
    return(
        <UI.Pressable {...props}>
            <Box borderWidth={2} borderRadius={3} borderColor={selected ? 'orange.500' : 'transparent'} overflow="hidden" transition="all 0.2s">
                <Image src={data?.image_url} />
                <Box p={4}>
                    <Text fontWeight="bold">{data?.label}</Text>
                    <Text fontSize="xs" color="GrayText">{data?.tagline}</Text>
                    { selected && <Badge mt={2} colorPalette="orange">Selecionado</Badge>}
                </Box>
            </Box>
        </UI.Pressable>
    )
}